import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./AboutUs.css";

const AboutUs = () => {
  return (
    <>
      {/* HERO SECTION */}
      <section className="about-hero">
        <Container>
          <div className="about-hero-content">
            <span className="about-badge">About Us</span>
            <h1>Plenary Holidays</h1>
            <p>Defining Excellence in Global Travel & MICE</p>
          </div>
        </Container>
      </section>

      {/* 16 YEAR LEGACY */}
      <section className="about-section">
        <Container>
          <h2>A 16-Year Legacy of Trust & Professional Excellence</h2>
          <p>
            Established in 2010, Plenary Holidays has spent over 16 years delivering structured, dependable, and high-impact travel solutions. Headquartered in our owned corporate office in Netaji Subhash Place, New Delhi, we operate with the infrastructure, stability, and governance required to manage complex corporate travel programs and large-scale group movements.
          </p>
          <p>
            What began as a boutique travel service has evolved into a professionally managed, full-service Travel Management Company (TMC) with strong capabilities across leisure, inbound tourism, and MICE.
          </p>
          <p>
            Today, Plenary Holidays operates across two core verticals:
          </p>
          <ul>
            <li>Leisure Travel (Domestic, Inbound & International Holidays)</li>
            <li>MICE & Corporate Travel Management</li>
          </ul>
        </Container>
      </section>

      {/* GLOBAL PARTICIPATION */}
      <section className="about-section light">
        <Container>
          <h2>A Recognized Global Industry Participant</h2>
          <p>
            Plenary Holidays actively engages with the global travel and hospitality ecosystem. Our leadership and team regularly participate in premier international and national platforms, strengthening partnerships and staying aligned with global trends.
          </p>
          <p>We are active participants in:</p>
          <ul>
            <li>Global Travel Platforms: ITB (Berlin & Asia), OTM, SATTE</li>
            <li>B2B & MICE Forums: BLTM and specialized MICE summits</li>
            <li>Institutional & Policy Engagement: FICCI, CII, and government-conducted tourism and trade events</li>
          </ul>
          <p>
            Our presence across these forums reflects not just participation, but commitment to industry collaboration, compliance standards, and continuous professional evolution.
          </p>
        </Container>
      </section>

      {/* CORE SPECIALIZATIONS */}
      <section className="about-section">
        <Container>
          <h2>Our Core Specializations</h2>

          <h4>MICE & Corporate Travel Management</h4>
          <p>
            We are structured group travel and MICE specialists. From conceptualizing corporate offsites to executing international conferences and incentive programs, we manage the complete lifecycle of corporate travel.
          </p>
          <p>Our approach integrates:</p>
          <ul>
            <li>Strategic planning aligned with business objectives</li>
            <li>Venue sourcing and vendor negotiations</li>
            <li>Airline and logistics coordination</li>
            <li>Budget optimization and compliance management</li>
            <li>On-ground supervision and execution</li>
          </ul>
          <p>
            Every program is designed with precision, accountability, and measurable outcomes in mind.
          </p>
        </Container>
      </section>

      {/* INDIAN & INBOUND */}
      <section className="about-section light">
        <Container>
          <h2>Curated Indian & Inbound Experiences</h2>
          <p>
            With deep regional expertise across Uttarakhand, Himachal Pradesh, Rajasthan, Sikkim, and North East India, we design immersive and culturally rooted travel experiences.
          </p>
          <p>Our portfolio includes:</p>
          <ul>
            <li>Luxury Pilgrimage Programs</li>
            <li>Photography & Experiential Tours</li>
            <li>Biking & Adventure Expeditions</li>
            <li>Customized Family & Group Holidays</li>
          </ul>
          <p>
            For inbound travelers, we curate structured itineraries that showcase India’s heritage, diversity, and authenticity.
          </p>
        </Container>
      </section>

      {/* OVERSEAS */}
      <section className="about-section">
        <Container>
          <h2>Overseas Leisure & Strategic Alliances</h2>
          <p>
            Through long-standing partnerships with global DMCs, hotel consolidators, and airline networks across the Far East, Mauritius, Europe, and other key destinations, we deliver curated international travel experiences backed by strong commercial value.
          </p>
          <p>
            Our technology-enabled ticketing and travel systems ensure real-time support, competitive pricing, and seamless global coordination.
          </p>
        </Container>
      </section>

      {/* WHY PLENARY */}
      <section className="about-section light">
        <Container>
          <h2>Why Plenary Holidays</h2>

          <h4>Established Infrastructure</h4>
          <p>
            Operate with confidence knowing you are working with a company that maintains a permanent, owned corporate office and structured operational framework.
          </p>

          <h4>Certified & Trained Specialists</h4>
          <p>
            Our team holds recognized certifications from leading tourism boards including Canada, France (Atout France), Thailand, Dubai, California, Germany, and others.
          </p>

          <h4>Compliance & Ethical Standards</h4>
          <p>We are proud registered members of:</p>
          <ul>
            <li>Global Association of Events & Hospitality Professionals (GAEHP)</li>
            <li>Association of Domestic Tour Operators of India (ADTOI)</li>
          </ul>
          <p>
            These affiliations reflect our commitment to professional ethics, compliance, and industry best practices.
          </p>
        </Container>
      </section>

      {/* TEAM & VALUES */}
      <section className="about-section">
        <Container>
          <h2>Our Team & Professional Values</h2>
          <p>
            Our specialists are not merely travel coordinators—they are trained advisors who provide informed, practical guidance based on firsthand destination knowledge.
          </p>
          <p>We invest consistently in:</p>
          <ul>
            <li>Training programs</li>
            <li>Industry certifications</li>
            <li>Site inspections and destination familiarization visits</li>
          </ul>
          <p>
            This ensures our recommendations are grounded in experience, not brochures.
          </p>
        </Container>
      </section>

      {/* CERTIFICATIONS */}
      <section className="about-section light">
        <Container>
          <h2>Industry Certifications & Continuous Development</h2>
          <p>Our team has successfully completed specialist programs including:</p>
          <ul>
            <li>Thailand Tourism Expert Program</li>
            <li>Atout France Certification</li>
            <li>AMADEUS Training Program</li>
            <li>Dubai Xpert Program</li>
            <li>Canada Specialist (Level II)</li>
            <li>California Expert</li>
            <li>Punjab Tourism Board Certification</li>
            <li>Madhya Pradesh Tourism Board Certification</li>
            <li>Multiple destination-focused professional development programs</li>
          </ul>
          <p>
            Continuous education remains central to our service philosophy.
          </p>
        </Container>
      </section>

      {/* PHILOSOPHY */}
      <section className="about-section">
        <Container>
          <h2>Our Philosophy</h2>
          <p>
            For over 16 years, Plenary Holidays has operated on three guiding principles:
          </p>
          <ul>
            <li>Structured Planning</li>
            <li>Transparent Pricing</li>
            <li>Reliable Execution</li>
          </ul>
          <p>
            Whether managing a high-value corporate incentive program, an international conference, or a curated family holiday, our focus remains consistent: deliver operational excellence, measurable value, and long-term client relationships.
          </p>
        </Container>
      </section>
    </>
  );
};

export default AboutUs;